import React, { useEffect } from "react";
import { Drawer } from "antd";
import {
  CloseOutlined,
  ExportOutlined,
  ShoppingCartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AppContext } from "Store";
import mcampaigns from "Images/mobile/mcampaigns.svg";
import mcart from "Images/mobile/mcart.svg";
import mprofile from "Images/mobile/mprofile.svg";
import config, {
  SESSION_STORAGE_KEY_MAP,
  stockCenterAdminLoginUrl,
  stockCenterSelectCustomerUrl,
  stockCenterUserCenterUrl,
  USER_TYPE,
} from "Utils/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { getSelectedSTObj } from "Utils/addressUtils";
import { getAuthToken, handleLogin } from "Utils/common";
import { getCartCount } from "Utils/apiUtils";
import cookie from "js-cookie";

const MFooter: React.FC<any> = (props) => {
  const { loginState, cartCount, setCartCount } =
    React.useContext(AppContext);
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const { activityId, refreshCartCount, navItem2, cartTitle } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [accountOpen, setAccountOpen] = React.useState(false);
  const employeeEmail = loginState?.proxyUser?.email || "";
  const loginDisplayName = loginState?.proxyUser?.username || "";

  const gotoMyProfile = () => {
    window.location.href = stockCenterUserCenterUrl;
  };

  const gotoStockCenter = () => {
    window.location.href = stockCenterSelectCustomerUrl;
  };

  const logoutEmployee = () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY_MAP.AUTH_TOKEN);
    window.location.href = stockCenterAdminLoginUrl;
  };

  const renderDrawerTitle = (label: string, onClose: () => void) => (
    <div className="mobileDrawerTitleBar">
      <div className="mobileAccountSummary">
        <div className="mobileAccountSummaryText">
          <div className="mobileAccountSummaryName">{loginDisplayName || "-"}</div>
          <div className="mobileAccountSummaryEmail">{employeeEmail || "-"}</div>
        </div>
      </div>
      <button
        type="button"
        className="mobileDrawerCloseBtn"
        onClick={onClose}
      >
        <CloseOutlined />
      </button>
    </div>
  );

  useEffect(() => {
    if (refreshCartCount && loginState.status === "login") {
      const selectedST = getSelectedSTObj(loginState);
      getCartCount(activityId, (count: number) => {
        setCartCount(count);
      }, selectedST?.accountNumber);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityId, refreshCartCount, loginState.status]);

  return (
    <div className="mobilePageFooter">
      <div className="footerContent">
        {!isEmployee &&
        <div
          className="navItem"
          onClick={() => {
            if (loginState.status === "login") {
              cookie.set("token", loginState.token, {
                secure: true,
                sameSite: "strict",
              });
            }
            window.location.href = `${config.APPLICATION_ENDPOINT}/promotions`;
          }}
        >
          <img src={mcampaigns} alt=""></img>
          <span>全部活动</span>
        </div>
        }
        {navItem2 === "activity" ? (
          <div
            className="navItem"
            onClick={() => {
              const searchParams = new URLSearchParams(location.search);
              navigate(`/m/${activityId}?${searchParams.toString()}`);
            }}
          >
            <img src={mcart} alt=""></img>
            <span>当前活动</span>
          </div>
        ) : (
          <div
            className="navItem"
            onClick={() => {
              if (loginState.status === "login") {
                if (!location.pathname.startsWith("/m/myCart")) {
                  const searchParams = new URLSearchParams(location.search);
                  searchParams.delete("filter");
                  navigate(`/m/myCart/${activityId}?${searchParams.toString()}`, {

                  });
                }
              } else {
                handleLogin();
              }
            }}
          >
            <img src={mcart} alt=""></img>
            <span>{cartTitle || "已选产品"}</span>
            {loginState.status === "login" && <span className="cartCount">{cartCount}</span>}
          </div>
        )}
        <div
          className="navItem"
          onClick={() => {
            if (isEmployee) {
              setAccountOpen(true);
              return;
            }

            if (loginState.status === "login") {
              cookie.set("token", getAuthToken(), {
                secure: true,
                sameSite: "strict",
              });
            }
            window.location.href = `${config.APPLICATION_ENDPOINT}/more`;
          }}
        >
          <img src={mprofile} alt=""></img>
          <span>我的</span>
        </div>
      </div>
      <Drawer
        title={renderDrawerTitle("账号信息", () => setAccountOpen(false))}
        placement="bottom"
        height="auto"
        open={accountOpen}
        onClose={() => setAccountOpen(false)}
        className="mobileFooterAccountDrawer"
        closable={false}
      >
        <div className="mobileAccountPanel">
         
          <button
            type="button"
            className="mobileAccountAction"
            onClick={gotoMyProfile}
          >
            <span className="mobileAccountActionMain">
              <UserOutlined className="mobileAccountActionIcon" />
              <span>个人信息</span>
            </span>
          </button>
          <button
            type="button"
            className="mobileAccountAction"
            onClick={gotoStockCenter}
          >
            <span className="mobileAccountActionMain">
              <ShoppingCartOutlined className="mobileAccountActionIcon" style={{ fontSize: 16 }} />
              <span>客户列表</span>
            </span>
          </button>
          <button
            type="button"
            className="mobileAccountAction"
            onClick={logoutEmployee}
          >
            <span className="mobileAccountActionMain">
              <ExportOutlined className="mobileAccountActionIcon" />
              <span>退出</span>
            </span>
          </button>
        </div>
      </Drawer>
    </div>
  );
};

export default MFooter;
